module.exports = __webpack_public_path__ + "img/pt-21.0c0e5f38.jpg";